import { Box } from "@material-ui/core";
import React from "react";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import Seo from "../../components/SEO/seo";

const SolutionsLayout = ({ children, title,  }) => {
	return (
		<Box style={{backgroundColor:'white',}} width="100%" >
			<Box width="100%">
				<Seo title={title} />
				<NavBar />
				<Box >{children}</Box>
			</Box>
			<Footer />
		</Box>
	);
};
export default SolutionsLayout;
